import { useEffect, useState } from "react";
import "../../styles/ThirdParty/Validation.scss";
import {
  getPlantsData as greenBasicGetAllEmissionData,
  getStaticAttributes as greenBasicGetStaticAttributes,
} from "../../instantiateTransaction/basicGreenProject";
import {
  getPlantsData as infraBasicGetAllEmissionData,
  getStaticAttributes as infraBasicGetStaticAttributes,
} from "../../instantiateTransaction/basicInfrastructureChange";
import {
  getPlantsData as greenGovernanceGetAllEmissionData,
  getStaticAttributes as greenGovernanceGetStaticAttributes,
} from "../../instantiateTransaction/governanceGreenProject";
 
import {
  getPlantsData as governanceInfraGetAllEmissionData,
  getStaticAttributes as governanceInfraGetStaticAttributes,
} from "../../instantiateTransaction/gorvernanceInfrastructureChange";
 
import {
  getPlantsData as governanceMonitoringGetAllEmissionData,
  getStaticAttributes as governanceMonitoringGetStaticAttributes,
} from "../../instantiateTransaction/governanceCarbonMonitoring";
 
import { toast } from "react-toastify";
import { ethers } from "ethers";
import { getDatabase, ref, onValue, push, orderByChild, equalTo, query, update, } from "firebase/database";
import axios from "axios";
import { useRef } from "react";
import moment from "moment";
import {
  facilityValidate,
} from "../../apis/General/web3/shared";
import { useSelector } from "react-redux";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import Illustration from "../../images/9264828.jpg";
import ReactQuill from "react-quill";
import { getKyc, getUserInfo } from "../../apis/General/users";
import { useNavigate, useParams } from "react-router-dom";
import Kyc from "../../components/ThirdPartyDashboard/Kyc";
import SideBar from "../../components/AdminDashboard/SideBar";
import { Tab, Tabs } from "@mui/material";
import Search from "../../components/AdminDashboard/Search";
import { updateUserKyc } from "../../apis/AdminDashboard/users";
 import { createComment } from "../../apis/ThirdPartyDashboard/dashboard";
function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
 
const Validation = () => {
  const navigate = useNavigate();
  const auth = useSelector((state) => state.auth);
  console.log("auth", auth);
  const pathname = useParams();
  const mediaRef = useRef(null);
 
  const [modalOpen, setModalOpen] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [validateLoading, setValidateLoading] = useState(false);
  const [rejectLoading, setRejectLoading] = useState(false);
  const [activities, setActivities] = useState([]);
  const [loading, setLoading] = useState(false);
  const [facilityLoading, setFacilityLoading] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(null);
  const [selectedFacility, setSelectedFacility] = useState(null);
  const [content, setContent] = useState("");
  const [projectDescription, setProjectDescription] = useState("");
  const [quantifiedBaseYearInventory, setQuantifiedBaseYearInventory] =
    useState("");
  const [quantificationMethodology, setQuantificationMethodology] =
    useState("");
  const [selectedStaticAttributes, setSelectedStaticAttributes] =
    useState(null);
  const [selectedId, setSelectedId] = useState("");
  const [selectedKyc, setSelectedKyc] = useState("");
  const [reason, setReason] = useState("");
  const [value, setValue] = useState(0);
  const [facilityType, setFacilityType] = useState("green");
  const [greenBasicFacilitiesValidated, setGreenBasicFacilitiesValidated] =
    useState([]);
  const [greenBasicFacilitiesUnvalidated, setGreenBasicFacilitiesUnvalidated] =
    useState([]);
  const [infraBasicFacilitiesValidated, setInfraBasicFacilitiesValidated] =
    useState([]);
  const [infraBasicFacilitiesUnvalidated, setInfraBasicFacilitiesUnvalidated] =
    useState([]);
  const [
    greenGovernanceFacilitiesValidated,
    setGreenGovernanceFacilitiesValidated,
  ] = useState([]);
  const [
    greenGovernanceFacilitiesUnvalidated,
    setGreenGovernanceFacilitiesUnvalidated,
  ] = useState([]);
  const [
    infraGovernanceFacilitiesValidated,
    setInfraGovernanceFacilitiesValidated,
  ] = useState([]);
  const [
    infraGovernanceFacilitiesUnvalidated,
    setInfraGovernanceFacilitiesUnvalidated,
  ] = useState([]);
  const [selectedSubscriptionPlan, setSelectedSubscriptionPlan] = useState("");
  const [monitoringValidated, setMonitoringValidated] = useState([]);
  const [monitoringUnvalidated, setMonitoringUnvalidated] = useState([]);
  const [validatedLength, setValidatedLength] = useState(0);
  const [unValidatedLength, setUnValidatedLength] = useState(0);
  const [email, setEmail] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [scenario, setScenario] = useState("");
  const [organizationDescription, setOrganizationDescription] = useState("");
  const [publicKey, setPublicKey] = useState("");
  const [location, setLocation] = useState("");
  const [subscription, setSubscription] = useState("");
  const [fuelSource, setFuelSource] = useState("");
  const [renewableEnergySolutions, setRenewableEnergySolutions] = useState("");
  const [governmentOrganization, setGovernmentOrganization] = useState("");
  const [regulatoryStatus, setRegulatoryStatus] = useState("");
  const [images, setImages] = useState([]);
  const [uplaodLoading, setUploadLoading] = useState(false);
  const [kycKeys, setKycKeys] = useState([]);
  const [quantificationFile, setQuantificationFile] = useState(null);
  const [projectDesignFile, setProjectDesignFile] = useState(null);

  const handleQuantificationUpload = (e) => {
    const file = e.target.files[0];
    if (file) setQuantificationFile(file);
  };

  const handleProjectDesignUpload = (e) => {
    const file = e.target.files[0];
    if (file) setProjectDesignFile(file);
  };

  
 
  const [showDropdown, setShowDropdown] = useState(false);
  const [showUploadDocument, setShowUploadDocument] = useState(false)

  const [selectedReason, setSelectedReason] = useState("");
  const [selectedChecks, setSelectedChecks] = useState([]);
  const [additionalComment, setAdditionalInfo] = useState("");

  const toggleCheck = (value) => {
    setSelectedChecks((prev) =>
      prev.includes(value)
        ? prev.filter((item) => item !== value)
        : [...prev, value]
    );
  };
  const token =auth?.token
  const selectedKycID= selectedKyc
  console.log(selectedKycID)
const handleCommentUpload = async (e) => {
  e.preventDefault();
  const kycComment = await createComment(
    additionalComment,
    selectedReason,
  token,
    selectedKycID
  );
  console.log("kycComment", kycComment);
};

// const handleDocumentUpload = async (e) => {
//   e.preventDefault();

//   try {
//     if (!quantificationFile && !projectDesignFile) {
//       console.log("No files selected");
//       return;
//     }

//     // Convert files to object URLs (temporary local URLs)
//     const quantificationFileUrl = quantificationFile
//       ? URL.createObjectURL(quantificationFile)
//       : null;

//     const projectDesignFileUrl = projectDesignFile
//       ? URL.createObjectURL(projectDesignFile)
//       : null;

//     // Example: send to backend or log
//     const payload = {
//       quantificationDocument: quantificationFileUrl,
//       projectDesignDocument: projectDesignFileUrl,
//     };

//     console.log("Document Upload Payload:", payload);

//     // Example API POST (optional)
//     await axios.post(`${process.env.REACT_APP_API_URL}/kyc/v1/create-kyc`, (payload));

//     alert("Files converted to URLs successfully!");

//     // Clean up object URLs when done to free memory
//     if (quantificationFileUrl) URL.revokeObjectURL(quantificationFileUrl);
//     if (projectDesignFileUrl) URL.revokeObjectURL(projectDesignFileUrl);
//   } catch (error) {
//     console.error("Upload failed:", error);
//   }
// };


  // const handleSubmit = () => {
  //   console.log({ selectedReason, selectedChecks, additionalInfo });
  // };

  // const toggleOption = (option) => {
  //   setSelectedOptions((prev) =>
  //     prev.includes(option)
  //       ? prev.filter((o) => o !== option)
  //       : [...prev, option]
  //   );
  // };
  // if (!open) return null;
  const db = getDatabase();
  const tableRef = ref(db, "kycStatus");
 
  const handleTabChange = (event, newValue) => {
    console.log("newValue", newValue);
    setValue(newValue);
  };
 
  // useEffect(() => {
  //   if(auth?.userInfo?.role === "verifiers") {
  //     navigate("/third-party/verification")
  //   }
  // }, [auth])
 
  // const handleModalOpen = async (facility, index, subscriptionPlan) => {
  //   setCurrentIndex(index);
  //   setLoading(true);
  //   setSelectedSubscriptionPlan(subscriptionPlan)
  //   try {
  //     console.log("facility", facility, "subscriptionPlan", subscriptionPlan, facility?.scenario, facility?.scenario === "infrastructure-change");
  //     setSelectedFacility(facility);
  //     let response;
  //     if (
  //       facility?.scenario === "infrastructure-change"
  //       &&
  //       subscriptionPlan === "basic"
  //     ) {
  //       response = await infraBasicGetStaticAttributes(facility?.plantAddress);
  //     } else if (
  //       facility?.scenario === "green"
  //       &&
  //       subscriptionPlan === "basic"
  //     ) {
  //       response = await greenBasicGetStaticAttributes(facility?.plantAddress);
  //     } else if (
  //       facility?.scenario === "infrastructure-change"
  //       &&
  //       subscriptionPlan === "governance"
  //     ) {
  //       response = await governanceInfraGetAllEmissionData(facility?.plantAddress);
  //     } else if (
  //       facility?.scenario === "green"
  //       &&
  //       subscriptionPlan === "governance"
  //     ) {
  //       response = await greenGovernanceGetStaticAttributes(facility?.plantAddress);
  //     } else if (facility?.scenario === "carbon-monitoring") {
  //       response = await governanceMonitoringGetStaticAttributes(
  //         facility?.plantAddress
  //       );
  //     } else {
  //       alert("Invalid Scenario");
  //     }
  //     console.log("response static", response);
  //     const response2 = await getKyc(
  //       facility?.scenario === "green" && subscriptionPlan === "basic"
  //         ? response?.staticAttributes[5] :
  //         facility?.scenario === "infrastructure-change" && subscriptionPlan === "basic"
  //           ? response?.staticAttributes[6] :
  //           facility?.scenario === "green" && subscriptionPlan === "governance"
  //             ? response?.staticAttributes[7] :
  //             facility?.scenario === "infrastructure-change" && subscriptionPlan === "governance"
  //               ? response?.staticAttributes[7] :
  //               response?.staticAttributes[7],
  //       auth?.token
  //     );
  //     console.log("response2", response2);
  //     setSelectedStaticAttributes(response?.staticAttributes);
  //     setSelectedKyc(response2?.data?.message);
  //     setSelectedId(
  //       facility?.scenario === "green" && subscriptionPlan === "basic"
  //         ? response?.staticAttributes[5] :
  //         facility?.scenario === "infrastructure-change" && subscriptionPlan === "basic"
  //           ? response?.staticAttributes[6] :
  //           facility?.scenario === "green" && subscriptionPlan === "governance"
  //             ? response?.staticAttributes[7] :
  //             facility?.scenario === "infrastructure-change" && subscriptionPlan === "governance"
  //               ? response?.staticAttributes[7] :
  //               response?.staticAttributes[7]
  //     );
  //     // setModalOpen(true);
  //     setShowForm(true);
 
  //   } catch (error) {
  //     console.log("ERROR", error);
  //     toast.error("Something went wrong");
  //   }
  //   setFacilityLoading(false);
  // };
 
 
 
  const handleModalOpen = async (facility, index, subscriptionPlan) => {
    setCurrentIndex(index);
    setLoading(true);
    setSelectedSubscriptionPlan(subscriptionPlan);
 
    try {
      console.log("facility", facility, "subscriptionPlan", subscriptionPlan, facility?.scenario, facility?.scenario === "infrastructure-change");
      setSelectedFacility(facility);
 
      let response;
      if (
        facility?.scenario === "non-green" &&
        subscriptionPlan === "basic"
      ) {
        console.log("Case: non-green + basic");
        response = await infraBasicGetStaticAttributes(facility?.plantAddress);
      } else if (
        facility?.scenario === "green" &&
        subscriptionPlan === "basic"
      ) {
        console.log("Case: green + basic");
        response = await greenBasicGetStaticAttributes(facility?.plantAddress);
      } else if (
        facility?.scenario === "non-green" &&
        subscriptionPlan === "governance"
      ) {
        console.log("Case: non-green + governance");
        // response = await governanceInfraGetAllEmissionData(facility?.plantAddress);
        response = await governanceInfraGetStaticAttributes(facility?.plantAddress);
      } else if (
        facility?.scenario === "green" &&
        subscriptionPlan === "governance"
      ) {
        console.log("Case: green + governance");
        response = await greenGovernanceGetStaticAttributes(facility?.plantAddress);
 
      } else if (facility?.scenario === "carbon-monitoring") {
        console.log("Case: carbon-monitoring");
        response = await governanceMonitoringGetStaticAttributes(
          facility?.plantAddress
        );
      } else {
        alert("Invalid Scenario");
        return;
      }
 
      console.log("response static", response);
 
      // Get the user ID from static attributes
      const userId = facility?.scenario === "green" && subscriptionPlan === "basic"
        ? response?.staticAttributes[5] :
        facility?.scenario === "non-green" && subscriptionPlan === "basic"
          ? response?.staticAttributes[6] :
          facility?.scenario === "green" && subscriptionPlan === "governance"
            ? response?.staticAttributes[7] :
            facility?.scenario === "non-green" && subscriptionPlan === "governance"
              ? response?.staticAttributes[7] :
              response?.staticAttributes[7];
 
      // Fetch both user info and KYC using the same user ID
      const [userInfoResponse, kycResponse] = await Promise.all([
        getUserInfo(userId, auth?.token),
        getKyc(userId, auth?.token)
      ]);
 
      console.log("userInfoResponse", userInfoResponse);
      console.log("kycResponse", kycResponse);
 
      // Set user info
      setEmail(userInfoResponse?.data?.message?.email);
      setFirstName(userInfoResponse?.data?.message?.firstName);
      setLastName(userInfoResponse?.data?.message?.lastName);
      setCompanyName(userInfoResponse?.data?.message?.companyName);
 
      // Set KYC and other data
      setSelectedStaticAttributes(response?.staticAttributes);
      setSelectedKyc(kycResponse?.data?.message);
      console.log("setSelectedKyc",setSelectedKyc)
      setQuantificationMethodology(kycResponse?.data?.message?.quantificationMethodology || "");
 
      setSelectedId(userId);
      setShowForm(true);
 
    } catch (error) {
      console.log("ERROR", error);
      toast.error("Something went wrong");
    }
    setFacilityLoading(false);
  };
 
  const handleModalClose = (e) => {
    if (e.target.classList.contains("modal")) {
      setModalOpen(false);
    }
  };
 
  const getValidationData = async () => {
    setLoading(true);
    // console.log('wemba')
 
    try {
      const response6 = await greenBasicGetAllEmissionData(0, 20);
      console.log("response6", response6);
 
      const temp1 = response6?.getAllInfo?.filter((item) => !!item?.isValidated);
      const temp2 = response6?.getAllInfo?.filter((item) => !item?.isValidated);
      setGreenBasicFacilitiesValidated(temp1);
      setGreenBasicFacilitiesUnvalidated(temp2);
 
      const response7 = await infraBasicGetAllEmissionData(0, 20);
      console.log("response7", response7);
 
      const temp3 = response7?.getAllInfo?.filter((item) => !!item?.isValidated);
      const temp4 = response7?.getAllInfo?.filter((item) => !item?.isValidated);
 
      setInfraBasicFacilitiesValidated(temp3);
      setInfraBasicFacilitiesUnvalidated(temp4);
 
      const response8 = await greenGovernanceGetAllEmissionData(0, 20);
      console.log("response8", response8);
 
      const temp5 = response8?.getAllInfo?.filter((item) => !!item?.isValidated);
      const temp6 = response8?.getAllInfo?.filter((item) => !item?.isValidated);
 
      setGreenGovernanceFacilitiesValidated(temp5);
      setGreenGovernanceFacilitiesUnvalidated(temp6);
 
      const response9 = await governanceInfraGetAllEmissionData(0, 20);
      console.log("response9", response9);
 
      const temp7 = response9?.getAllInfo?.filter((item) => !!item?.isValidated);
      const temp8 = response9?.getAllInfo?.filter((item) => !item?.isValidated);
 
      setInfraGovernanceFacilitiesValidated(temp7);
      setInfraGovernanceFacilitiesUnvalidated(temp8);
 
      const response10 = await governanceMonitoringGetAllEmissionData(0, 20);
      console.log('response10', response10);
 
      const temp9 = response10?.getAllInfo?.filter(
        (item) => !!item?.isValidated
      );
      const temp10 = response10?.getAllInfo?.filter(
        (item) => !item?.isValidated
      );
 
      setMonitoringValidated(temp9);
      setMonitoringUnvalidated(temp10);
 
      setValidatedLength(
        temp1?.length +
        temp3?.length +
        temp5?.length +
        temp7?.length +
        temp9?.length
      );
 
      setUnValidatedLength(
        temp2?.length +
        temp4?.length +
        temp6?.length +
        temp8?.length +
        temp10?.length
      );
    } catch (error) {
      console.log("ERROR FROM FRONTEND", error);
      // toast.error("Something went wrong");
    }
    setLoading(false);
    // console.log("response8", response8);
    // console.log('end of the road');
  };
 
 
 
  const getActivities = async () => {
    // console.log('bank');
    // setLoading(true);
    const database = getDatabase();
 
    const newRef = ref(database, "events");
    await onValue(newRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        setActivities(Object.values(data));
      }
      // setLoading(false);
    });
  };
 
  useEffect(() => {
    // setLoading(true)
    getValidationData();
    getActivities();
    // setLoading(false)
  }, []);
 
  const getLastActivity = (address) => {
    if (!activities || activities.length === 0) {
      return "Loading...";
    }
 
    console.log("Checking activities for address:", address);
 
    const filteredData = activities?.filter(
      (item) =>
        item?.addressToRecord === address && item?.type === "Plant Validated"
    );
 
    console.log("Filtered activities for address:", address, filteredData);
 
    if (filteredData?.length > 0) {
      const lastData = filteredData[filteredData.length - 1];
      console.log("Last validation data:", lastData);
 
      return moment(parseInt(lastData?.timestamp) * 1000).format("Do MMM YYYY [at] hh:mm A");
    }
 
    return "No validation date available";
  };
 
 
  const fileUpload = (e, documentTypeSent) => {
    setUploadLoading(true);
 
    let files = e.target.files;
    console.log("FILE", files)
    let allUploadedFiles = images;
 
    const fileToUri = (file, cb) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function () {
        cb(null, reader.result);
      };
      reader.onerror = function (error) {
        cb(error, null);
      };
    };
 
    if (files) {
      for (let i = 0; i < files.length; i++) {
        fileToUri(files[0], (err, result) => {
          if (result) {
            axios
              .post(
                `${process.env.REACT_APP_API_URL}/open/v1/upload`,
                {
                  media_type: "docx",
                  folder: "word_documents",
                  user_id: auth?.userInfo?.id,
                  contents: [result],
                },
                {
                  headers: {
                    Authorization: `Bearer ${auth ? auth.token : ""}`,
                  },
                }
              )
              .then((response) => {
                setQuantificationMethodology(response?.data?.body?.data[0]);
 
                setUploadLoading(false);
              })
              .catch((err) => {
                setUploadLoading(false);
              });
          }
        });
      }
    }
  };
 
  const handleUpdateKyc = async () => {
    setLoading(true);
    // let ipfsHash;
 
    // try {
    //   if (scenario === "green-project") {
    //     const fileResponse = await greenpinFileToIPFSAsync([
    //       organizationBoundary,
    //       historicalInventory,
    //       typeofFuel,
    //       quantificationMethodology,
    //       projectMonitoringReport,
    //       projectDescriptionReport,
    //       descriptionOfRenewableEnergySources,
    //     ]);
    //     ipfsHash = fileResponse?.IpfsHash;
    //   } else if (scenario === "carbon-monitoring") {
    //     const fileResponse = await infastructurepinFileToIPFSAsync([
    //       organizationBoundary,
    //       historicalInventory,
    //       typeofFuel,
    //       quantificationMethodology,
    //       projectMonitoringReport,
    //       projectDescriptionReport,
    //     ]);
    //     ipfsHash = fileResponse?.IpfsHash;
    //   } else if (scenario === "infrastructure-change") {
    //     const fileResponse = await infastructurepinFileToIPFSAsync([
    //       organizationBoundary,
    //       historicalInventory,
    //       typeofFuel,
    //       quantificationMethodology,
    //       projectMonitoringReport,
    //       projectDescriptionReport,
    //     ]);
    //     ipfsHash = fileResponse?.IpfsHash;
    //   } else {
    //     toast.error("Invalid Scenario");
    //   }
    // } catch (error) {
    //   console.log("ERROR", error);
    //   toast.error("Something went wrong");
    // }
 
    const response = await updateUserKyc(
      "perform kyc",
      subscription,
      companyName,
      publicKey,
      organizationDescription,
      location,
      facilityType,
      scenario,
      quantificationMethodology,
      fuelSource ? fuelSource : "fuelSource",
      renewableEnergySolutions ? renewableEnergySolutions : "renewableEnergySolutions",
      governmentOrganization ? governmentOrganization : "governmentOrganization",
      regulatoryStatus ? regulatoryStatus : "regulatoryStatus",
      pathname?.id,
      auth?.token
    );
 
    console.log("responseresponse", response);
    if (response?.data?.statusCode === 200) {
      update(ref(db, `kycStatus/${kycKeys[0]}`), {
        status: "completed",
      });
      toast.success("Kyc updated successfully");
    } else if (response?.data?.errorMessage) {
      toast.error(response?.data?.errorMessage);
    } else if (response?.status === 504) {
      toast.error(response?.data?.message);
    } else {
      toast.error("Something went wrong");
    }
 
    setLoading(false);
  };
 
  const handleValidate = async (facility) => {
    setValidateLoading(true);
    let response;
    try {
      if (facility?.isValidated) {
        alert(
          "Validation has already been carried out for this Facility's data"
        );
        setModalOpen(false);
        return;
      }
      // else if (facility?.isVerified) {
      //   alert(
      //     "Verification has already been carried out for this Facility's data"
      //   );
      //   setModalOpen(false);
      // }
      else if (facility?.isRejected) {
        alert("This Facility's data failed Validation or Verification");
        setModalOpen(false);
      }
      else if (
        facility?.scenario === "infrastructure-change" && selectedSubscriptionPlan === "basic"
      ) {
        response = await facilityValidate(
          selectedId,
          facility?.plantAddress,
          "infrastructure-change",
          "basic",
          auth?.token
        );
      }
      else if (
        facility?.scenario === "green" && selectedSubscriptionPlan === "basic"
      ) {
        response = await facilityValidate(
          selectedId,
          facility?.plantAddress,
          "green",
          "basic",
          auth?.token
        );
      } else if (facility?.scenario === "infrastructure-change" && selectedSubscriptionPlan === "governance"
      ) {
        response = await facilityValidate(
          selectedId,
          facility?.plantAddress,
          "infrastructure-change",
          "governance",
          auth?.token
        );
      }
      else if (facility?.scenario === "green" && selectedSubscriptionPlan === "governance"
      ) {
        console.log("selectedKyc?.subscriptionPlan", selectedKyc, selectedKyc?.subscriptionPlan);
        response = await facilityValidate(
          selectedId,
          facility?.plantAddress,
          "green",
          "governance",
          auth?.token
        );
      }
      else if (facility?.scenario === "carbon-monitoring") {
        response = await facilityValidate(
          selectedId,
          facility?.plantAddress,
          "carbon-monitoring",
          "governance",
          auth?.token
        );
      }
      else {
        alert("Invalid Scenario");
        setLoading(false)
        return;
      }
      console.log("repsonse", response);
      if (response?.data?.statusCode === 200) {
        toast.success("Validation Successful");
        setModalOpen(false);
        setShowForm(false);
        push(ref(db, "notifications"), {
          type: "Validation successful",
          read: false,
          user: selectedId,
          reason,
          timestamp: Date.now(),
        });
        getValidationData();
      } else if (response?.data?.errorMessage) {
        toast.error(response?.data?.errorMessage);
      } else if (response?.data?.message) {
        toast.error(response?.data?.message);
      } else {
        toast.error("Something went wrong");
      }
    } catch (error) {
      console.log("ERROR", error);
      toast.error("Something went wrong");
    }
    setValidateLoading(false);
  };
 
 
// If showForm is true, display the form
  if (showForm) {
    return (
      <div className="thirdparty_validation">
        <div className="sidebar_container">
          <SideBar />
        </div>
        <div className="max-w-[1178px] w-[999px]  mx-auto bg-[#FAFAFA] rounded-2xl overflow-hidden ">
 
          <div className="main p-6 space-y-6 ">
            <button
              className=" items-center  text-gray-600 hover:text-gray-900"
              onClick={() => setShowForm(false)}
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 12H5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                <path d="M12 19L5 12L12 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </button>
            <div className="flex items-center space-x-4">
              <label className="block text-[14px] font-[400] text-[#101828] w-[235px] flex-shrink-0">First name</label>
              <input
                type="text"
                className="flex-1 w-[528px] h-[59px] px-3 py-2 text-[16px] border border-gray-300 rounded-2xl text-[#101828]  bg-[#FAFAFA] "
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
                readOnly
              />
            </div>
            <div className="flex items-center space-x-4">
              <label className="block text-[14px] font-[400] text-[#101828] w-[235px] flex-shrink-0">Last name</label>
              <input
                type="text"
                className="flex-1 w-[528px] h-[59px] px-3 py-2 text-[16px] border border-gray-300 rounded-2xl text-[#101828]  bg-[#FAFAFA] "
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
                readOnly
              />
            </div>
            <div className="flex items-center space-x-4">
              <label className="block text-[14px] font-[400] text-[#101828] w-[235px] flex-shrink-0">Email</label>
              <input
                type="text"
                className="flex-1 w-[528px] h-[59px] px-3 py-2 text-[16px] border border-gray-300 rounded-2xl text-[#101828]  bg-[#FAFAFA] "
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                readOnly
              />
            </div>
            <div className="flex items-center space-x-4">
              <label className="block text-[14px] font-[400] text-[#101828] w-[235px] flex-shrink-0">Company name</label>
              <input
                type="text"
                className="flex-1 w-[528px] h-[59px] px-3 py-2 text-[16px] border border-gray-300 rounded-2xl text-[#101828]  bg-[#FAFAFA] "
                value={companyName}
                onChange={(e) => setCompanyName(e.target.value)}
 
                readOnly
              />
            </div>
 
 
            <div className="flex items-center space-x-4">
              <label className="block text-[14px] mt-8 font-[400] text-[#101828] w-[235px] flex-shrink-0 pt-2"> {selectedFacility?.scenario === "green"
                ? "Green project name"
                : "Facility name"}</label>
              <input
                type="text"
                className="flex-1 w-[528px] h-[59px] px-3 py-2 text-[16px] border border-gray-300 rounded-2xl text-[#101828]  bg-[#FAFAFA] "
                // value={selectedFacility?.organizationName || ''}
                value={selectedFacility?.scenario === "green" ? selectedKyc?.greenProjectName : selectedKyc?.facilityName}
 
                readOnly
              />
            </div>
 
            <div className="flex items-start space-x-4">
              <label className="block text-[14px] mt-8 font-[400] text-[#101828] w-[235px] flex-shrink-0 pt-2"> {selectedFacility?.scenario === "green"
                ? "Green project description"
                : "Facility description"}</label>
              <textarea
                rows="4"
                className="flex-1 h-[116px] w-[528px] text-[16px]   px-3 py-2 border border-gray-300  bg-gray-50 rounded-2xl text-[#101828] "
                value={selectedFacility?.scenario === "green" ? selectedKyc?.greenProjectDescription : selectedKyc?.facilityDescription}
                readOnly
              />
            </div>
 
            <div className="flex items-center space-x-4">
              <label className="block text-[14px] font-[400] text-[#101828] w-[235px] flex-shrink-0">
                {selectedFacility?.scenario === "green"
                  ? "Green project location"
                  : "Facility location"}
              </label>
              <input
                type="text"
                className="flex-1 w-[528px] h-[59px] px-3 py-2 text-[16px] border border-gray-300 rounded-2xl text-[#101828]  bg-[#FAFAFA] "
                value={selectedFacility?.scenario === "green" ? selectedKyc?.greenProjectLocation : selectedKyc?.facilityLocation}
                readOnly
              />
            </div>
 
            <div className="flex items-center space-x-4">
              <label className="block text-[14px] font-[400] text-[#101828] w-[235px] flex-shrink-0">
                {selectedFacility?.scenario === "green"
                  ? "Green project start date"
                  : "Facility start date"}
              </label>
              <input
                type="text"
                className="flex-1 w-[528px] h-[59px] text-[16px] px-3 py-2 text-[16px] border border-gray-300 rounded-2xl text-[#101828]  bg-[#FAFAFA] "
                value={selectedFacility?.scenario === "green" ? selectedKyc?.greenProjectStartDate : selectedKyc?.facilityStartDate}
                readOnly
              />
            </div>
 
            {selectedFacility?.scenario !== "carbon-monitoring" && (
              <div className="flex items-center space-x-4">
                <label className="block text-[14px] font-[400] text-[#101828] w-[235px] flex-shrink-0">    {selectedFacility?.scenario === "green"
                  ? "Renewable energy"
                  : "Project fuel source"
                }</label>
                <input
                  type="text"
                  className="flex-1 w-[528px] h-[59px] px-3 py-2 text-[16px] border border-gray-300 rounded-2xl text-[#101828]  bg-[#FAFAFA] "
                  value={selectedFacility?.scenario === "green" ? selectedKyc?.renewableEnergySolutions : selectedKyc?.projectFuelSource}
                  readOnly
                />
              </div>
            )}
 
            {selectedFacility?.scenario !== "carbon-monitoring" && (
              <div className="flex items-start space-x-4">
                <label className="block text-[14px] font-[400] mt-8 text-[#101828] w-[235px] flex-shrink-0 pt-2">
                  Baseline scenario
                </label>
                <textarea
                  rows="4"
                  className="flex-1 h-[116px] text-[16px] px-3 py-2 border border-gray-300  bg-gray-50 rounded-2xl text-[#101828] "
 
                  value={selectedKyc?.baseLineScenario}
                  readOnly
                />
              </div>
            )}
 
            {selectedFacility?.scenario !== "carbon-monitoring" && (
              <div className="flex items-center space-x-4">
                <label className="block text-[14px] font-[400] text-[#101828] w-[235px] flex-shrink-0">
                  {selectedFacility?.scenario === "green" ? "Energy source in baseline scenario" : "Fuel source in baseline scenario"}
                </label>
                <input
                  type="text"
                  className="flex-1 w-[528px] h-[59px] px-3 py-2 text-[16px] border border-gray-300 rounded-2xl text-[#101828]  bg-[#FAFAFA] "
                  value={selectedFacility?.scenario === "green" ? selectedKyc?.baseLineEnergySource : selectedKyc?.baseLineEnergySource}
                  readOnly
                />
              </div>
            )}
            {selectedFacility?.scenario !== "carbon-monitoring" && (
              <div className="flex items-start space-x-4">
                <label className="block text-[14px] font-[400] mt-8 text-[#101828] w-[235px] flex-shrink-0 pt-2">Additional information relevant to the project</label>
                <textarea
                  rows="4"
                  className="flex-1 h-[116px] text-[16px]  px-3 py-2 border border-gray-300  bg-gray-50 rounded-2xl text-[#101828] "
 
                  value={selectedKyc?.additionalInfomation}
                  readOnly
                />
              </div>
            )}
 
            <div className="flex items-center space-x-4">
              <label className="block text-[14px] font-[400] text-[#101828] w-[235px] flex-shrink-0">Facility Capacity</label>
              <input
                type="text"
                className="flex-1 w-[528px] h-[59px] px-3 py-2 text-[16px] border border-gray-300 rounded-2xl text-[#101828]  bg-[#FAFAFA] "
                value={selectedKyc?.facilityCapacity}
                readOnly
              />
            </div>
 
            <div className="flex items-center space-x-4">
              <label className="block text-[14px] font-[400] text-[#101828] w-[235px] flex-shrink-0">Facility category</label>
              <input
                type="text"
                className="flex-1 w-[528px] h-[59px] px-3 py-2 text-[16px] border border-gray-300 rounded-2xl text-[#101828]  bg-[#FAFAFA] "
                value={selectedKyc?.facilityCategory}
                readOnly
              />
            </div>
 
            <div className="flex items-center space-x-4">
              <label className="block text-[14px] font-[400] text-[#101828] w-[235px] flex-shrink-0">Double counting and participation under other GHG programs</label>
              <input
                type="text"
                className="flex-1 w-[528px] h-[59px] px-3 py-2 text-[16px] border border-gray-300 rounded-2xl text-[#101828]  bg-[#FAFAFA] "
                value="NO"
                readOnly
              />
            </div>

            
            {/* Proof of fuel source in baseline scenario */}
            <div className="flex  space-y-2">
              <label className="block text-[14px] font-[400] text-[#101828] w-[235px] flex-shrink-0">
                Proof of fuel source in baseline scenario
                {/* <span className="text-red-500 ml-1">*</span> */}
              </label>
 
              <div className="w-[900px] h-[59px] px-3 py-2 border border-gray-300 rounded-2xl text-[#101828] bg-[#FAFAFA]">
                <label className="">
                  <div
                    className="document input  flex items-center justify-between cursor-pointer"
                    onClick={() =>
                      quantificationMethodology !== "" &&
                      window.open(quantificationMethodology)
                    }
                  >
                    <div className="text-[14px] text-[#667185] justify-center flex items-center py-2">
                      {uplaodLoading
                        ? "Loading..."
                        : quantificationMethodology?.length > 0
                          ? "Document uploaded"
                          : "Choose file to upload"}
                    </div>
                    {quantificationMethodology?.length > 0 ? (
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M7.5 1.5C6.70435 1.5 5.94129 1.81607 5.37868 2.37868C4.81607 2.94129 4.5 3.70435 4.5 4.5V19.5C4.5 20.2956 4.81607 21.0587 5.37868 21.6213C5.94129 22.1839 6.70435 22.5 7.5 22.5H16.5C17.2956 22.5 18.0587 22.1839 18.6213 21.6213C19.1839 21.0587 19.5 20.2956 19.5 19.5V8.121C19.4995 7.52446 19.2621 6.95255 18.84 6.531L14.4705 2.1585C14.2615 1.9496 14.0133 1.78393 13.7403 1.67094C13.4672 1.55795 13.1745 1.49987 12.879 1.5H7.5ZM6 4.5C6 4.10218 6.15804 3.72064 6.43934 3.43934C6.72064 3.15804 7.10218 3 7.5 3H12V6.75C12 7.34674 12.2371 7.91903 12.659 8.34099C13.081 8.76295 13.6533 9 14.25 9H18V19.5C18 19.8978 17.842 20.2794 17.5607 20.5607C17.2794 20.842 16.8978 21 16.5 21H7.5C7.10218 21 6.72064 20.842 6.43934 20.5607C6.15804 20.2794 6 19.8978 6 19.5V4.5ZM17.6895 7.5H14.25C14.0511 7.5 13.8603 7.42098 13.7197 7.28033C13.579 7.13968 13.5 6.94891 13.5 6.75V3.3105L17.6895 7.5Z"
                          fill="#667185"
                        />
                      </svg>
                    ) : (
                      <div className="underline text-green-700 text-[14px]">View Document</div>
                    )}
                  </div>
                  {quantificationMethodology === "" && (
                    <input
                      type="file"
                      multiple
                      // accept='video/*'
                      accept=".doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                      hidden
                      onChange={fileUpload}
                      ref={mediaRef}
                    />
                  )}
                </label>
                {/* <div className="mt-12 text-[12px] text-gray-500">
                  <button
                    className="transparent"
                    onClick={() => {
                      setQuantificationMethodology("");
                    }}
 
                    disabled={loading}
                  >
                    {loading ? "Loading..." : "Cancel"}
                  </button>
                  <button
                    className="filled"
                    disabled={loading}
                    onClick={handleUpdateKyc}
                  >
                    {loading ? "Loading..." : "Save changes"}
                  </button>
                </div> */}
              </div>
 
            </div>
 
            {/* QUANTIFICATION METHODOLOGY SECTION - ADDED */}
            <div className="flex  space-y-2">
              <label className="block text-[14px] font-[400] text-[#101828] w-[235px] flex-shrink-0">
                Quantification Methodology
                {/* <span className="text-red-500 ml-1">*</span> */}
              </label>
 
              <div className="w-[900px] h-[59px] px-3 py-2 border border-gray-300 rounded-2xl text-[#101828] bg-[#FAFAFA]">
                <label className="">
                  <div
                    className="document input  flex items-center justify-between cursor-pointer"
                    onClick={() =>
                      quantificationMethodology !== "" &&
                      window.open(quantificationMethodology)
                    }
                  >
                    <div className="text-[14px] text-[#667185] justify-center flex items-center py-2">
                      {uplaodLoading
                        ? "Loading..."
                        : quantificationMethodology?.length > 0
                          ? "Document uploaded"
                          : "Choose file to upload"}
                    </div>
                    {quantificationMethodology?.length > 0 ? (
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M7.5 1.5C6.70435 1.5 5.94129 1.81607 5.37868 2.37868C4.81607 2.94129 4.5 3.70435 4.5 4.5V19.5C4.5 20.2956 4.81607 21.0587 5.37868 21.6213C5.94129 22.1839 6.70435 22.5 7.5 22.5H16.5C17.2956 22.5 18.0587 22.1839 18.6213 21.6213C19.1839 21.0587 19.5 20.2956 19.5 19.5V8.121C19.4995 7.52446 19.2621 6.95255 18.84 6.531L14.4705 2.1585C14.2615 1.9496 14.0133 1.78393 13.7403 1.67094C13.4672 1.55795 13.1745 1.49987 12.879 1.5H7.5ZM6 4.5C6 4.10218 6.15804 3.72064 6.43934 3.43934C6.72064 3.15804 7.10218 3 7.5 3H12V6.75C12 7.34674 12.2371 7.91903 12.659 8.34099C13.081 8.76295 13.6533 9 14.25 9H18V19.5C18 19.8978 17.842 20.2794 17.5607 20.5607C17.2794 20.842 16.8978 21 16.5 21H7.5C7.10218 21 6.72064 20.842 6.43934 20.5607C6.15804 20.2794 6 19.8978 6 19.5V4.5ZM17.6895 7.5H14.25C14.0511 7.5 13.8603 7.42098 13.7197 7.28033C13.579 7.13968 13.5 6.94891 13.5 6.75V3.3105L17.6895 7.5Z"
                          fill="#667185"
                        />
                      </svg>
                    ) : (
                      <div className="underline text-green-700 text-[14px]">View Document</div>
                    )}
                  </div>
                  {quantificationMethodology === "" && (
                    <input
                      type="file"
                      multiple
                      // accept='video/*'
                      accept=".doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                      hidden
                      onChange={fileUpload}
                      ref={mediaRef}
                    />
                  )}
                </label>
                {/* <div className="mt-12 text-[12px] text-gray-500">
                  <button
                    className="transparent"
                    onClick={() => {
                      setQuantificationMethodology("");
                    }}
 
                    disabled={loading}
                  >
                    {loading ? "Loading..." : "Cancel"}
                  </button>
                  <button
                    className="filled"
                    disabled={loading}
                    onClick={handleUpdateKyc}
                  >
                    {loading ? "Loading..." : "Save changes"}
                  </button>
                </div> */}
              </div>
 
            </div>



            {/* Project Design Document */}
            <div className="flex  space-y-2">
              <label className="block text-[14px] font-[400] text-[#101828] w-[235px] flex-shrink-0">
                Project Design Document
                {/* <span className="text-red-500 ml-1">*</span> */}
              </label>
 
              <div className="w-[900px] h-[59px] px-3 py-2 border border-gray-300 rounded-2xl text-[#101828] bg-[#FAFAFA]">
                <label className="">
                  <div
                    className="document input  flex items-center justify-between cursor-pointer"
                    onClick={() =>
                      quantificationMethodology !== "" &&
                      window.open(quantificationMethodology)
                    }
                  >
                    <div className="text-[14px] text-[#667185] justify-center flex items-center py-2">
                      {uplaodLoading
                        ? "Loading..."
                        : quantificationMethodology?.length > 0
                          ? "Document uploaded"
                          : "Choose file to upload"}
                    </div>
                    {quantificationMethodology?.length > 0 ? (
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M7.5 1.5C6.70435 1.5 5.94129 1.81607 5.37868 2.37868C4.81607 2.94129 4.5 3.70435 4.5 4.5V19.5C4.5 20.2956 4.81607 21.0587 5.37868 21.6213C5.94129 22.1839 6.70435 22.5 7.5 22.5H16.5C17.2956 22.5 18.0587 22.1839 18.6213 21.6213C19.1839 21.0587 19.5 20.2956 19.5 19.5V8.121C19.4995 7.52446 19.2621 6.95255 18.84 6.531L14.4705 2.1585C14.2615 1.9496 14.0133 1.78393 13.7403 1.67094C13.4672 1.55795 13.1745 1.49987 12.879 1.5H7.5ZM6 4.5C6 4.10218 6.15804 3.72064 6.43934 3.43934C6.72064 3.15804 7.10218 3 7.5 3H12V6.75C12 7.34674 12.2371 7.91903 12.659 8.34099C13.081 8.76295 13.6533 9 14.25 9H18V19.5C18 19.8978 17.842 20.2794 17.5607 20.5607C17.2794 20.842 16.8978 21 16.5 21H7.5C7.10218 21 6.72064 20.842 6.43934 20.5607C6.15804 20.2794 6 19.8978 6 19.5V4.5ZM17.6895 7.5H14.25C14.0511 7.5 13.8603 7.42098 13.7197 7.28033C13.579 7.13968 13.5 6.94891 13.5 6.75V3.3105L17.6895 7.5Z"
                          fill="#667185"
                        />
                      </svg>
                    ) : (
                      <div className="underline text-green-700 text-[14px]">View Document</div>
                    )}
                  </div>
                  {quantificationMethodology === "" && (
                    <input
                      type="file"
                      multiple
                      // accept='video/*'
                      accept=".doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                      hidden
                      onChange={fileUpload}
                      ref={mediaRef}
                    />
                  )}
                </label>
                {/* <div className="mt-12 text-[12px] text-gray-500">
                  <button
                    className="transparent"
                    onClick={() => {
                      setQuantificationMethodology("");
                    }}
 
                    disabled={loading}
                  >
                    {loading ? "Loading..." : "Cancel"}
                  </button>
                  <button
                    className="filled"
                    disabled={loading}
                    onClick={handleUpdateKyc}
                  >
                    {loading ? "Loading..." : "Save changes"}
                  </button>
                </div> */}
              </div>
 
            </div>

 
            {/* {!selectedFacility?.isValidated && ( */}
              <div className="pt-6 flex justify-end space-x-4 max-w-[400px] ml-auto">
                <button
                  className="reject-button flex-1 h-[52px] text-[16px] border border-gradient-to-br from-[#038B47] to-[#00AED9] bg-gray-200 text-[#006633] rounded-2xl hover:bg-gray-300 font-medium transition-colors"
                  onClick={() => {
                    setQuantificationMethodology("");
                    // setShowForm(false);
                    // setModalOpen(true)
                    setShowDropdown(true)

                  }}
                >
                  Leave Comment
                </button>
                <button
                  className="flex-1 h-[52px] text-[16px] text-white bg-gradient-to-br from-[#038B47] to-[#00AED9] rounded-2xl hover:opacity-90 disabled:opacity-50 disabled:cursor-not-allowed font-medium transition-colors"
                  onClick={() => {
                    // setModalOpen(true);
                    handleUpdateKyc();
                  }}
                  disabled={facilityLoading || !quantificationMethodology}
                >
                  {facilityLoading ? "Loading..." : "Validate"}
                </button>
              </div>
            {/* )} */}
          </div>
{
  showDropdown && (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center mx-auto  justify-center z-50" onClick={()=>showDropdown}>
     <div
      className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm flex items-center justify-center z-50"
      // onClick={onClose}
      onClick={setShowDropdown}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="relative bg-white w-[579px] max-w-[90%] h-[612px] rounded-3xl p-8 flex flex-col shadow-lg"
      >
        {/* Header */}
        <div className="flex items-center gap-2 mb-6">
       <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M14.9965 7.00065H3.82651L8.70651 2.12065C9.09651 1.73065 9.09651 1.09065 8.70651 0.700647C8.61399 0.607943 8.5041 0.534396 8.38313 0.484214C8.26216 0.434033 8.13248 0.408203 8.00151 0.408203C7.87054 0.408203 7.74086 0.434033 7.61988 0.484214C7.49891 0.534396 7.38902 0.607943 7.29651 0.700647L0.706507 7.29065C0.613803 7.38316 0.540256 7.49305 0.490074 7.61402C0.439893 7.735 0.414063 7.86468 0.414062 7.99565C0.414063 8.12662 0.439893 8.2563 0.490074 8.37727C0.540256 8.49824 0.613803 8.60813 0.706507 8.70065L7.29651 15.2906C7.38909 15.3832 7.499 15.4567 7.61996 15.5068C7.74093 15.5569 7.87058 15.5827 8.00151 15.5827C8.13244 15.5827 8.26209 15.5569 8.38305 15.5068C8.50401 15.4567 8.61392 15.3832 8.70651 15.2906C8.79909 15.1981 8.87253 15.0882 8.92263 14.9672C8.97274 14.8462 8.99853 14.7166 8.99853 14.5856C8.99853 14.4547 8.97274 14.3251 8.92263 14.2041C8.87253 14.0831 8.79909 13.9732 8.70651 13.8806L3.82651 9.00065H14.9965C15.5465 9.00065 15.9965 8.55065 15.9965 8.00065C15.9965 7.45065 15.5465 7.00065 14.9965 7.00065Z" fill="black"/>
</svg> Back

          <h2 className="text-[#101828] font-medium text-2xl mx-auto">
            Leave Comment
          </h2>
        </div>
        <form onSubmit={handleCommentUpload}>


        {/* Reason for comment */}
        <div className="flex flex-col gap-3 mb-6">
          <label className="text-[#101828] font-semibold text-[16px]">
            Reason for comment
          </label>

          <div className="relative">
            <select
              value={selectedReason}
              onChange={(e) => setSelectedReason(e.target.value)}
              className="w-full border border-[#D0D5DD] rounded-lg px-4 py-3 text-[#667185] text-[14px] appearance-none bg-white focus:outline-none focus:ring-2 focus:ring-[#00AED9]"
            >
              <option value="" disabled>
                Select reason
              </option>
              
              <option className="text-[#898989] text-[14px] leading-[21px] font-normal" value="Missing/inconsistent company name - unclear ownership.">
                Missing/inconsistent company name - unclear ownership.
              </option>
              <option value="Incorrect industry/facility category.">
                Incorrect industry/facility category.
              </option>
              <option value="Missing facility capacity.">Missing facility capacity.</option>
              <option value="Vague facility/project description - unclear technology or activity.">
               Vague facility/project description - unclear technology or activity.
              </option>
              <option value="Missing or inaccurate facility/project location.">
                Missing or inaccurate facility/project location.
              </option>
              <option value="Unspecified facility/project fuel source.">
                Unspecified facility/project fuel source.
              </option>
              <option value="Unjustified or incorrect baseline scenario.">
                Unjustified or incorrect baseline scenario.
              </option>
              <option value="Wrong or missing fuel source in baseline scenario.">
               Wrong or missing fuel source in baseline scenario.
              </option>
              <option value="Missing/untraceable supporting documents.">
              Missing/untraceable supporting documents.
              </option>
              <option value="Double counting & ghg participation..">
            Double counting & ghg participation.
              </option>
            </select>

            {/* Custom dropdown arrow */}
            <svg
              className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 pointer-events-none"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M7 10l5 5 5-5"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
        </div>


        {/* Additional Info */}
        <div className="flex flex-col gap-3 mb-8">
          <label className="text-[#101828] font-semibold text-[16px]">
            Additional Information
          </label>
          <textarea
            value={additionalComment}
            onChange={(e) => setAdditionalInfo(e.target.value)}
            placeholder="Enter additional details here..."
            className="w-full h-[120px] border border-[#D0D5DD] rounded-lg p-4 text-[#667185] text-[14px] resize-none focus:outline-none focus:ring-2 focus:ring-[#00AED9]"
          />
        </div>

        {/* Submit Button */}
        <button
          // onClick={handleSubmit}
          className="mt-auto w-full py-4 bg-gradient-to-r from-[#038B47] to-[#00AED9] text-white rounded-2xl font-semibold text-[16px] hover:opacity-90 transition"
        >
          Submit
        </button>

        </form>


      </div>
    </div>
</div>
       
  )
}
          
          {modalOpen && (
            <div
              className="fixed inset-0 bg-black bg-opacity-50 flex items-center mx-auto  justify-center z-50"
              onClick={handleModalClose}
            >
              <div
                className="bg-white rounded-xl  p-8 w-[579px] max-w-[90%] h-[329px] relative text-center"
                onClick={(e) => e.stopPropagation()}
              >
                {/* Close Button (SVG circle with X) */}
                <button
                  aria-label="Close modal"
                  onClick={() => setModalOpen(false)}
                  className="absolute top-4 right-4 w-12 h-12 rounded-full bg-white flex items-center justify-center"
                >
                  {/* SVG: circle with X inside.
            width and height set to the exact values you gave,
            svg positioned inside the button with top/left offsets. */}
                  <svg
                    width="20.730209350585938"
                    height="21.071121215820312"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    style={{ position: "relative", top: "1.48px", left: "1.47px", opacity: 1 }}
                    aria-hidden="true"
                    focusable="false"
                  >
                    {/* Outer circle */}
                    <circle cx="11.5" cy="11.5" r="10" fill="#FFFFFF" stroke="#D0D5DD" strokeWidth="1" />
                    {/* X mark */}
                    <path
                      d="M7.5 7.5L15.5 15.5M15.5 7.5L7.5 15.5"
                      stroke="#667085"
                      strokeWidth="1.6"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </button>
 
 
                {/* Title */}
                <h2 className="text-[#101828] mt-24 font-semibold font-[600px] text-[24px] mb-4">
                  Confirm KYC Validation
                </h2>
 
                {/* Description */}
                <p className="text-[#667185]  text-[16px] font-[400px] mb-8">
                  Are you sure you want to validate this user’s KYC details?
                  <br />
                  Once validated, it can not be changed.
                </p>
 
                {/* Buttons */}
                <div className="flex justify-center gap-8 ">
                  {/* Cancel Button */}
                  <button
                    className="w-[209px] h-[70px]  border border-[#D0D5DD] rounded-2xl text-[#344054] text-[16px] font-medium"
                    onClick={() => setModalOpen(false)}
                  >
                    Cancel
                  </button>
 
                  {/* Confirm Button */}
                  <button
                    onClick={() => handleValidate(selectedFacility)}
                    disabled={loading}
                    className="w-[209px] h-[70px] rounded-2xl bg-gradient-to-r from-[#038B47] to-[#00AED9] text-white text-[16px] font-medium  disabled:opacity-50"
                  >
                    {loading ? "Loading..." : "Confirm"}
                  </button>
                </div>
              </div>
            </div>
          )}
 
 
        </div >
      </div >
    );
  }
 
 
  return (
    <div className="thirdparty_validation">
      <div className="sidebar_container">
        <SideBar />
      </div>
      <div className="main">
        <Search />
        <Tabs
          value={value}
          onChange={handleTabChange}
          aria-label="project tabs"
          className="tab_label_container"
        >
          {/* Unvalidated Projects */}
          <Tab
            className={value === 0 ? "tab_label tab_active" : "tab_label"}
            label={
              <div className="tab-label-content">
                <span>Unvalidated Projects</span>
                <span className="tab-label-content__count">
                  {greenBasicFacilitiesUnvalidated.length +
                    greenGovernanceFacilitiesUnvalidated.length +
                    infraBasicFacilitiesUnvalidated.length +
                    infraGovernanceFacilitiesUnvalidated.length +
                    monitoringUnvalidated.length}
                </span>
              </div>
            }
            {...a11yProps(0)}
          />
 
          {/* Validated Projects */}
          < Tab
            className={value === 1 ? "tab_label tab_active" : "tab_label"}
            label={
              < div className="tab-label-content" >
                <span>Validated Projects</span>
                <span className="tab-label-content__count">
                  {greenBasicFacilitiesValidated.length +
                    greenGovernanceFacilitiesValidated.length +
                    infraBasicFacilitiesValidated.length +
                    infraGovernanceFacilitiesValidated.length +
                    monitoringValidated.length}
                </span >
              </div >
            }
            {...a11yProps(1)}
          />
      

        
          {/* Validated Projects */}
          < Tab
            className={value === 2 ? "tab_label tab_active" : "tab_label"}
            label={
              < div className="tab-label-content" >
                <span>Comments</span>
                <span className="tab-label-content__count">
                  {greenBasicFacilitiesValidated.length +
                    greenGovernanceFacilitiesValidated.length +
                    infraBasicFacilitiesValidated.length +
                    infraGovernanceFacilitiesValidated.length +
                    monitoringValidated.length}
                </span >
              </div >
            }
            {...a11yProps(1)}
          />
        </Tabs >
 
        <div className="validation-table">
          <div className="validation-table__header">
            <div className="flex gap-3">
 
              {/* Green */}
              <button
                className={`sub-btn ${facilityType === "green" ? "active" : ""}`}
                onClick={() => setFacilityType("green")}
              >
                Green
                <span className="sub-btn__count">
                  {value === 0
                    ? greenBasicFacilitiesUnvalidated.length +
                    greenGovernanceFacilitiesUnvalidated.length
                    : greenBasicFacilitiesValidated.length +
                    greenGovernanceFacilitiesValidated.length}
                </span>
              </button>
 
              {/* Non-green */}
              <button
                className={`sub-btn ${facilityType === "non-green" ? "active" : ""}`}
                onClick={() => setFacilityType("non-green")}
              >
                Non-green
                <span className="sub-btn__count">
                  {value === 0
                    ? infraBasicFacilitiesUnvalidated.length +
                    infraGovernanceFacilitiesUnvalidated.length
                    : infraBasicFacilitiesValidated.length +
                    infraGovernanceFacilitiesValidated.length}
                </span>
              </button >
 
              {/* Carbon Monitoring */}
              < button
                className={`sub-btn ${facilityType === "carbon-monitoring" ? "active" : ""}`}
                onClick={() => setFacilityType("carbon-monitoring")}
              >
                Carbon Monitoring
                < span className="sub-btn__count" >
                  {value === 0
                    ? monitoringUnvalidated.length
                    : monitoringValidated.length}
                </span >
              </button >
            </div >
          </div >
 
 
          {!loading &&
            value === 0 &&
            greenBasicFacilitiesUnvalidated?.length === 0 &&
            infraBasicFacilitiesUnvalidated?.length === 0 &&
            greenGovernanceFacilitiesUnvalidated?.length === 0 &&
            infraGovernanceFacilitiesUnvalidated?.length === 0 &&
            monitoringUnvalidated?.length === 0 && (
              <div className="empty_list">
                <img src={Illustration} alt="" />
                <div>No validation data here yet</div>
              </div >
            )}
 
          {
            !loading &&
            value === 1 &&
            greenBasicFacilitiesValidated?.length === 0 &&
            infraBasicFacilitiesValidated?.length === 0 &&
            greenGovernanceFacilitiesValidated?.length === 0 &&
            infraGovernanceFacilitiesValidated?.length === 0 &&
            monitoringValidated?.length === 0 && (
              <div className="empty_list">
                <img src={Illustration} alt="" />
                <div>No validation data here yet</div>
 
              </div >
            )}
          {/* {greenFacilities?.length > 0 && (
          <div className="category">Green Project</div>
        )} */}
          {
            value === 1 &&
            facilityType === "green" &&
            greenBasicFacilitiesValidated?.map((facility, index) => (
              <div className="validation_card">
                <div className="title_group">
                  <div className="card_title">
                    Organisations Name - {facility?.organizationName}
                  </div>
                </div >
                <div className="card_divider"></div>
 
                <div className="flex gap-[30px] text-[16px]">
                  <div>
                    <div>Facility Name:</div>
                    <div>
                      {facility?.organizationName && facility?.organizationName}
                    </div>
                  </div >
                  {/* <div>
              <div>Methodology:</div>
              <div>CloseCarbon</div>
            </div> */}
                  <div>
                    <div>Facility category:</div>
                    <div>Green</div>
                  </div >
                  <div>
                    <div>Sustainability solution:</div>
                    <div>Green project</div>
                  </div >
                  <div>
                    <div>Plan</div>
                    <div>Basic</div>
                  </div >
 
                  <button
                  className="underline ml-20 text-green-700 "
                    onClick={() => handleModalOpen(facility, index, "basic")}
                    disabled={facilityLoading}
                  >
                    {facilityLoading && index === currentIndex
                      ? "Loading..."
                      : "View Document"}
                  </button >
                </div >
                <div></div>
                <div className="confirm">
                  <div className="log">
                    Date of validation:
                    {getLastActivity(facility?.plantAddress)}
                  </div>
 
                </div>
                {/* <div className="log">
                  <span>Last Activity:</span>{" "}
                  {getLastActivity(facility?.plantAddress)}
                </div> */}
              </div>
            ))}
          {value === 0 &&
            facilityType === "green" &&
            greenBasicFacilitiesUnvalidated?.map((facility, index) => (
              <div className="validation_card">
                <div className="title_group">
                  <div className="text-[16px] text-bold pb-10">
                    {/* Organisation Name - David */}
                    {facility?.organizationName}
                  </div>
                </div>
                {/* <div className="card_divider"></div> */}
                <hr className=" pb-10"></hr>
 
                <div className="flex gap-[25px] ">
                  <div>
                    <div className="text-[14px]">Facility Name:</div>
                    <div className="text-gray-600 text-[14px]" >
                      {/* David */}
                      {facility?.organizationName && facility?.organizationName}
                    </div>
                  </div >
                 
                  <div>
                    <div className="text-[14px]">Facility category:</div>
                    <div className="text-gray-500 text-[14px]">Green</div>
                  </div >
                  <div>
                    <div className="text-[14px]">Sustainability solution:</div>
                    <div className="text-gray-500 text-[14px]">Green project</div>
                  </div >
                  <div>
                    <div className="text-[14px]">Plan</div>
                    <div className="text-gray-500 text-[14px]">Basic</div>
                  </div >
 <div className="float-right ml-20 flex gap-8">

                  <button
                  onClick={setShowUploadDocument}
                    className="underline ml-44 text-green-700  text-[14px]"
                    
                    // onClick={() => handleModalOpen(facility, index, "basic")}
                    // disabled={facilityLoading}
                  >
                    {/* View Document  */}
                    {facilityLoading && index === currentIndex
                      ? "Loading..."
                      : "Validate"}
                  </button >

                  {/* validate  */}

                                 <button onClick={setShowForm} className="flex items-center justify-center gap-3 px-4 py-2 w-[145px] h-[45px]  
                 rounded-lg text-white font-semibold text-[16px] leading-6 
                 bg-gradient-to-r from-[#038B47] to-[#00AED9] 
                 hover:opacity-90 transition">
                  

                  Validate
                </button>
 
 </div>
        
                </div >
 
 
                <div className="log">
              {/* <span>Last Activity:</span>{" "} */}
              {getLastActivity(facility?.plantAddress)}
            </div> 
              </div>
           ))}  
          {value === 1 &&
            facilityType === "green" &&
            greenGovernanceFacilitiesValidated?.map((facility, index) => (
              <div className="validation_card">
                <div className="title_group">
                  <div className="card_title">
                    Organisation Name - {facility?.organizationName}
                  </div>
                </div>
                <div className="card_divider"></div>
 
                <div className="validation_grid">
                  <div>
                    <div>Facility Name:</div>
                    <div>
                      {facility?.organizationName && facility?.organizationName}
                    </div>
                  </div >
                  {/* <div>
              <div>Methodology:</div>
              <div>CloseCarbon</div>
            </div> */}
                  <div>
                    <div>Facility category:</div>
                    <div>Green</div>
                  </div >
                  <div>
                    <div>Sustainability solution:</div>
                    <div>Green project</div>
                  </div >
                  <div>
                    <div>Plan</div>
                    <div>Governance</div>
                  </div >
 
                  <button
                    className="confirm-button"
                    onClick={() => handleModalOpen(facility, index, "governance")}
                    disabled={facilityLoading}
                  >
                    {facilityLoading && index === currentIndex
                      ? "Loading..."
                      : "View Document"}
                  </button >
                </div >
 
                <div className="confirm">
                  <div>Date of validation</div>
                  {/* <div>{getLastActivity(facility?.plantAddress)}</div> */}
 
                </div>
                {/* <div className="log">
              <span>Last Activity:</span>{" "}
              {getLastActivity(facility?.plantAddress)}
            </div> */}
              </div>
            ))}
          {value === 0 &&
            facilityType === "green" &&
            greenGovernanceFacilitiesUnvalidated?.map((facility, index) => (
              <div className="validation_card">
                <div className="title_group">
                  <div className="card_title">
                    Organisation Name - {facility?.organizationName}
                  </div>
                </div>
                <div className="card_divider"></div>
 
                <div className="validation_grid">
                  <div>
                    <div>Facility Name:</div>
                    <div>
                      {facility?.organizationName && facility?.organizationName}
                    </div>
                  </div >
                  {/* <div>
              <div>Methodology:</div>
              <div>CloseCarbon</div>
            </div> */}
                  <div>
                    <div>Facility category:</div>
                    <div>Green</div>
                  </div >
                  <div>
                    <div>Sustainability solution:</div>
                    <div>Green project</div>
                  </div >
                  <div>
                    <div>Plan</div>
                    <div>Governance</div>
                  </div >
 
                  <button
                    className="confirm-button"
                    onClick={() => handleModalOpen(facility, index, "governance")}
                    disabled={facilityLoading}
                  >
                    {facilityLoading && index === currentIndex
                      ? "Loading..."
                      : "Validate"}
                  </button >
                </div >
 
 
                {/* <div className="log">
              <span>Last Activity:</span>{" "}
              {getLastActivity(facility?.plantAddress)}
            </div> */}
              </div>
            ))}
          {/* {infrastructureChange?.length > 0 && (
          <div className="category">Infrastructure Change</div>
        )} */}
 
          {value === 1 &&
            facilityType === "non-green" &&
            infraBasicFacilitiesValidated?.map((facility, index) => (
              <div className="validation_card">
                <div className="title_group">
                  <div className="card_title">
                    Organisation Name - {facility?.organizationName}
                  </div>
                </div>
                <div className="card_divider"></div>
 
                <div className="validation_grid">
                  <div>
                    <div>Facility Name:</div>
                    <div>
                      {facility?.organizationName && facility?.organizationName}
                    </div>
                  </div >
                  {/* <div>
            <div>Methodology:</div>
            <div>CloseCarbon</div>
          </div> */}
                  <div>
                    <div>Facility category:</div>
                    <div>Non-green</div>
                  </div>
                  <div>
                    <div>Sustainability solution:</div>
                    <div>Infrastructure change</div>
                  </div >
                  <div>
                    <div>Plan</div>
                    <div>Basic</div>
                  </div >
 
                  <button
                    className="confirm-button"
                    onClick={() => handleModalOpen(facility, index, "basic")}
                    disabled={facilityLoading}
                  >
                    {facilityLoading && index === currentIndex
                      ? "Loading..."
                      : "View Document"}
                  </button >
                </div >
 
                <div className="confirm">
                  <div>Date of validation</div>
 
 
                </div>
                {/* <div className="log">
            <span>Last Activity:</span>{" "}
            {getLastActivity(facility?.plantAddress)}
          </div> */}
              </div>
            ))}
          {value === 0 &&
            facilityType === "non-green" &&
            infraBasicFacilitiesUnvalidated?.map((facility, index) => (
              <div className="validation_card">
                <div className="title_group">
                  <div className="card_title">
                    Organisation Name - {facility?.organizationName}
                  </div>
                </div>
                <div className="card_divider"></div>
 
                <div className="validation_grid">
                  <div>
                    <div>Facility Name:</div>
                    <div>
                      {facility?.organizationName && facility?.organizationName}
                    </div>
                  </div >
                  {/* <div>
            <div>Methodology:</div>
            <div>CloseCarbon</div>
          </div> */}
                  <div>
                    <div>Facility category:</div>
                    <div>Non-green</div>
                  </div>
                  <div>
                    <div>Sustainability solution:</div>
                    <div>Infrastructure change</div>
                  </div >
                  <div>
                    <div>Plan</div>
                    <div>Basic</div>
                  </div >
 
                  <button
                    className="confirm-button"
                    onClick={() => handleModalOpen(facility, index, "basic")}
                    disabled={facilityLoading}
                  >
                    {facilityLoading && index === currentIndex
                      ? "Loading..."
                      : "Validate"}
                  </button >
                </div >
 
 
                {/* <div className="log">
            <span>Last Activity:</span>{" "}
            {getLastActivity(facility?.plantAddress)}
          </div> */}
              </div>
            ))}
          {value === 1 &&
            facilityType === "non-green" &&
            infraGovernanceFacilitiesValidated?.map((facility, index) => (
              <div className="validation_card">
                <div className="title_group">
                  <div className="card_title">
                    Organisation Name - {facility?.organizationName}
                  </div>
                </div>
                <div className="card_divider"></div>
 
                <div className="validation_grid">
                  <div>
                    <div>Facility Name:</div>
                    <div>
                      {facility?.organizationName && facility?.organizationName}
                    </div>
                  </div >
                  {/* <div>
            <div>Methodology:</div>
            <div>CloseCarbon</div>
          </div> */}
                  <div>
                    <div>Facility category:</div>
                    <div>Non-green</div>
                  </div>
                  <div>
                    <div>Sustainability solution:</div>
                    <div>Infrastructure change</div>
                  </div >
                  <div>
                    <div>Plan</div>
                    <div>Governance</div>
                  </div >
 
                  <button
                    className="confirm-button"
                    onClick={() => handleModalOpen(facility, index, "governance")}
                    disabled={facilityLoading}
                  >
                    {facilityLoading && index === currentIndex
                      ? "Loading..."
                      : "View Document"}
                  </button >
                </div >
 
                <div className="confirm">
                  <div>Date of validation</div>
 
                </div>
                {/* <div className="log">
            <span>Last Activity:</span>{" "}
            {getLastActivity(facility?.plantAddress)}
          </div> */}
              </div>
            ))}
          {value === 0 &&
            facilityType === "non-green" &&
            infraGovernanceFacilitiesUnvalidated?.map((facility, index) => (
              <div className="validation_card">
                <div className="title_group">
                  <div className="card_title">
                    Organisation Name - {facility?.organizationName}
                  </div>
                </div>
                <div className="card_divider"></div>
 
                <div className="validation_grid">
                  <div>
                    <div>Facility Name:</div>
                    <div>
                      {facility?.organizationName && facility?.organizationName}
                    </div>
                  </div >
                  {/* <div>
            <div>Methodology:</div>
            <div>CloseCarbon</div>
          </div> */}
                  <div>
                    <div>Facility category:</div>
                    <div>Non-green</div>
                  </div>
                  <div>
                    <div>Sustainability solution:</div>
                    <div>Infrastructure change</div>
                  </div >
                  <div>
                    <div>Plan</div>
                    <div>Governance</div>
                  </div >
 
                  <button
                    className="confirm-button"
                    onClick={() => handleModalOpen(facility, index, "governance")}
                    disabled={facilityLoading}
                  >
                    {facilityLoading && index === currentIndex
                      ? "Loading..."
                      : "Validate"}
                  </button >
                </div >
 
 
                {/* <div className="log">
            <span>Last Activity:</span>{" "}
            {getLastActivity(facility?.plantAddress)}
          </div> */}
              </div>
            ))}
          {value === 1 &&
            facilityType === "non-green" &&
            monitoringValidated?.map((facility, index) => (
              <div className="validation_card">
                <div className="title_group">
                  <div className="card_title">
                    Organisation Name - {facility?.organizationName}
                  </div>
                </div>
                <div className="card_divider"></div>
 
                <div className="validation_grid">
                  <div>
                    <div>Facility Name:</div>
                    <div>
                      {facility?.organizationName && facility?.organizationName}
                    </div>
                  </div >
                  {/* <div>
            <div>Methodology:</div>
            <div>CloseCarbon</div>
          </div> */}
                  <div>
                    <div>Facility category:</div>
                    <div>Non-green</div>
                  </div>
                  <div>
                    <div>Sustainability solution:</div>
                    <div>Carbon monitoring</div>
                  </div >
                  <div>
                    <div>Plan</div>
                    <div></div>
                  </div >
 
                  <button
                    className="confirm-button"
                    onClick={() => handleModalOpen(facility, index, "governance")}
                    disabled={facilityLoading}
                  >
                    {facilityLoading && index === currentIndex
                      ? "Loading..."
                      : "View Document"}
                  </button >
                </div >
 
 
                {/* <div className="log">
            <span>Last Activity:</span>{" "}
            {getLastActivity(facility?.plantAddress)}
          </div> */}
              </div>
            ))}
          {value === 0 &&
            facilityType === "non-green" &&
            monitoringUnvalidated?.map((facility, index) => (
              <div className="validation_card">
                <div className="title_group">
                  <div className="card_title">
                    Organisation Name - {facility?.organizationName}
                  </div>
                </div>
                <div className="card_divider"></div>
 
                <div className="validation_grid">
                  <div>
                    <div>Facility Name:</div>
                    <div>
                      {facility?.organizationName && facility?.organizationName}
                    </div>
                  </div >
                  {/* <div>
            <div>Methodology:</div>
            <div>CloseCarbon</div>
          </div> */}
                  <div>
                    <div>Facility category:</div>
                    <div>Non-green</div>
                  </div>
                  <div>
                    <div>Sustainability solution:</div>
                    <div>Carbon monitoring</div>
                  </div >
                </div >
 
                <div className="confirm">
                  <div>Validate this facility</div>
 
                  <div>
                    {/* <button
                      onClick={() =>
                        alert(
                          "You have to carry out a site visit in order to proceed with Validation"
                        )
                      }
                      disabled={facilityLoading}
                    >
                      Cancel
                    </button> */}
                    <div></div>
                    <button
                      onClick={() => handleModalOpen(facility, index, "governance")}
                      disabled={facilityLoading}
                    >
                      {facilityLoading && index === currentIndex
                        ? "Loading..."
                        : "View details"}
                    </button>
                  </div >
                </div >
                {/* <div className="log">
            <span>Last Activity:</span>{" "}
            {getLastActivity(facility?.plantAddress)}
          </div> */}
              </div>
            ))}
          {/* {monitoring?.length > 0 && (
          <div className="category">Carbon Monitoring</div>
        )} */}



        {/* Show upload document  */}
        {
          showUploadDocument && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center mx-auto  justify-center z-50">
               <div className="absolute left-[420px] top-[226px] w-[600px] h-[500px] bg-white rounded-3xl p-6">
                <div className="text-center text-[#101828] text-2xl font-medium mb-6 mt-6" onClick={()=>setShowUploadDocument(false)} >

                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M14.9965 7.00065H3.82651L8.70651 2.12065C9.09651 1.73065 9.09651 1.09065 8.70651 0.700647C8.61399 0.607943 8.5041 0.534396 8.38313 0.484214C8.26216 0.434033 8.13248 0.408203 8.00151 0.408203C7.87054 0.408203 7.74086 0.434033 7.61988 0.484214C7.49891 0.534396 7.38902 0.607943 7.29651 0.700647L0.706507 7.29065C0.613803 7.38316 0.540256 7.49305 0.490074 7.61402C0.439893 7.735 0.414063 7.86468 0.414062 7.99565C0.414063 8.12662 0.439893 8.2563 0.490074 8.37727C0.540256 8.49824 0.613803 8.60813 0.706507 8.70065L7.29651 15.2906C7.38909 15.3832 7.499 15.4567 7.61996 15.5068C7.74093 15.5569 7.87058 15.5827 8.00151 15.5827C8.13244 15.5827 8.26209 15.5569 8.38305 15.5068C8.50401 15.4567 8.61392 15.3832 8.70651 15.2906C8.79909 15.1981 8.87253 15.0882 8.92263 14.9672C8.97274 14.8462 8.99853 14.7166 8.99853 14.5856C8.99853 14.4547 8.97274 14.3251 8.92263 14.2041C8.87253 14.0831 8.79909 13.9732 8.70651 13.8806L3.82651 9.00065H14.9965C15.5465 9.00065 15.9965 8.55065 15.9965 8.00065C15.9965 7.45065 15.5465 7.00065 14.9965 7.00065Z" fill="black"/>
Back </svg> 
</div>
      <div className="text-center text-[#101828] text-2xl font-medium mb-6 mt-6">
        View Document
      </div>
<form onSubmit={fileUpload} >

      {/* Quantification Methodology Document */}
      <div className="flex flex-col gap-3 mb-6">
        <label className="font-semibold text-[#101828] text-base">
          Quantification Methodology Document
        </label>

        {quantificationFile ? (
          <div className="flex items-center justify-between border border-[#038B47] rounded-lg p-3 py-10 w-[552px]">
            
            <div>
              
              <p className="text-[14px] font-medium text-[#101828] pl-5">
                {quantificationFile.name}
              </p>
              <p className="text-[12px] text-gray-500 pl-5">
                {(quantificationFile.size / 1024 / 1024).toFixed(1)}MB of 5MB
              </p>
            </div>
            <button
              onClick={() => setQuantificationFile(null)}
              // className="text-gray-500 hover:text-red-500"
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M8.625 4.5V2.25H15.375V4.5H8.625ZM6.375 4.5V1.5C6.375 1.10218 6.53304 0.720644 6.81434 0.43934C7.09564 0.158035 7.47718 0 7.875 0L16.125 0C16.5228 0 16.9044 0.158035 17.1857 0.43934C17.467 0.720644 17.625 1.10218 17.625 1.5V4.5H21.375C21.6734 4.5 21.9595 4.61853 22.1705 4.8295C22.3815 5.04048 22.5 5.32663 22.5 5.625C22.5 5.92337 22.3815 6.20952 22.1705 6.4205C21.9595 6.63147 21.6734 6.75 21.375 6.75H20.8275L19.713 21.2295C19.6552 21.9832 19.315 22.6872 18.7604 23.2009C18.2059 23.7146 17.4779 23.9999 16.722 24H7.278C6.52211 23.9999 5.79411 23.7146 5.23957 23.2009C4.68502 22.6872 4.34483 21.9832 4.287 21.2295L3.1725 6.75H2.625C2.32663 6.75 2.04048 6.63147 1.8295 6.4205C1.61853 6.20952 1.5 5.92337 1.5 5.625C1.5 5.32663 1.61853 5.04048 1.8295 4.8295C2.04048 4.61853 2.32663 4.5 2.625 4.5H6.375ZM5.43 6.75H18.57L17.469 21.057C17.4546 21.2454 17.3697 21.4214 17.2313 21.5498C17.0928 21.6783 16.9109 21.7498 16.722 21.75H7.278C7.0891 21.7498 6.90723 21.6783 6.76875 21.5498C6.63026 21.4214 6.54536 21.2454 6.531 21.057L5.43 6.75Z" fill="#667185"/>
</svg>

            </button>
          </div>
        ) : (
          <label className="flex flex-col items-center justify-center border border-dashed border-gray-400 rounded-lg h-[100px] cursor-pointer">
            <input
              type="file"
              className="hidden"
     onChange={handleQuantificationUpload}
            />
            <p className="text-sm text-[#101828] text-center">
              Choose a file or drag & drop here, max 5MB
            </p>
          </label>
        )}
      </div>

      {/* Project Design Document */}
      <div className="flex flex-col gap-3 mb-6">
        <label className="font-semibold text-[#101828] text-base">
          Project Design Document
        </label>

        {projectDesignFile ? (
          <div className="flex items-center justify-between border border-[#038B47] rounded-lg p-3 py-10 w-[552px]">
            <div>
              <p className="text-[14px] font-medium text-[#101828] pl-5">
                {projectDesignFile.name}
              </p>
              <p className="text-[12px] text-gray-500 pl-5">
                {(projectDesignFile.size / 1024 / 1024).toFixed(1)}MB of 5MB
              </p>
            </div>
            <button
              onClick={() => setProjectDesignFile(null)}
              // className="text-gray-500 hover:text-red-500"
            >        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M8.625 4.5V2.25H15.375V4.5H8.625ZM6.375 4.5V1.5C6.375 1.10218 6.53304 0.720644 6.81434 0.43934C7.09564 0.158035 7.47718 0 7.875 0L16.125 0C16.5228 0 16.9044 0.158035 17.1857 0.43934C17.467 0.720644 17.625 1.10218 17.625 1.5V4.5H21.375C21.6734 4.5 21.9595 4.61853 22.1705 4.8295C22.3815 5.04048 22.5 5.32663 22.5 5.625C22.5 5.92337 22.3815 6.20952 22.1705 6.4205C21.9595 6.63147 21.6734 6.75 21.375 6.75H20.8275L19.713 21.2295C19.6552 21.9832 19.315 22.6872 18.7604 23.2009C18.2059 23.7146 17.4779 23.9999 16.722 24H7.278C6.52211 23.9999 5.79411 23.7146 5.23957 23.2009C4.68502 22.6872 4.34483 21.9832 4.287 21.2295L3.1725 6.75H2.625C2.32663 6.75 2.04048 6.63147 1.8295 6.4205C1.61853 6.20952 1.5 5.92337 1.5 5.625C1.5 5.32663 1.61853 5.04048 1.8295 4.8295C2.04048 4.61853 2.32663 4.5 2.625 4.5H6.375ZM5.43 6.75H18.57L17.469 21.057C17.4546 21.2454 17.3697 21.4214 17.2313 21.5498C17.0928 21.6783 16.9109 21.7498 16.722 21.75H7.278C7.0891 21.7498 6.90723 21.6783 6.76875 21.5498C6.63026 21.4214 6.54536 21.2454 6.531 21.057L5.43 6.75Z" fill="#667185"/>
</svg>
            </button>
          </div>
        ) : (
          <label className="flex flex-col items-center justify-center border border-dashed border-gray-400 rounded-lg h-[100px] cursor-pointer">
            <input
              type="file"
              className="hidden"
               onChange={handleProjectDesignUpload}

                      // onChange={fileUpload}
                      // ref={mediaRef}
            />
            <p className="text-sm text-[#101828] text-center">
              Choose a file or drag & drop here, max 5MB
            </p>
          </label>
        )}
      </div>

      <button className="w-full py-8 mt-10 bg-gradient-to-r from-[#038B47] to-[#00AED9] rounded-lg text-white font-semibold">
       Save
      </button>
</form>


    </div>

              </div>
          )
        }
 
          {loading && (
            <>
              <div className="category">
                <Skeleton
                  width={120}
                  height={20}
                  borderRadius={8}
                  style={{ marginBottom: "8px" }}
                />
              </div>
              <div className="validation_card">
                <div className="validation_grid">
                  <div>
                    <div>
                      <Skeleton
                        width={"64%"}
                        height={20}
                        borderRadius={8}
                        style={{ marginBottom: "8px" }}
                      />
                    </div>
                    <div>
                      <Skeleton
                        width={"100%"}
                        height={20}
                        borderRadius={8}
                        style={{ marginBottom: "8px" }}
                      />
                    </div>
                  </div>
                  <div>
                    <div>
                      <Skeleton
                        width={"64%"}
                        height={20}
                        borderRadius={8}
                        style={{ marginBottom: "8px" }}
                      />
                    </div>
                    <div>
                      <Skeleton
                        width={"100%"}
                        height={20}
                        borderRadius={8}
                        style={{ marginBottom: "8px" }}
                      />
                    </div >
                  </div >
                  <div>
                    <div>
                      <Skeleton
                        width={"64%"}
                        height={20}
                        borderRadius={8}
                        style={{ marginBottom: "8px" }}
                      />
                    </div>
                    <div>
                      <Skeleton
                        width={"100%"}
                        height={20}
                        borderRadius={8}
                        style={{ marginBottom: "8px" }}
                      />
                    </div >
                  </div >
                  {/* <div>
              <div>Methodology:</div>
              <div>CloseCarbon</div>
            </div> */}
                </ div>
 
                <div className="log">
                  <Skeleton
                    width={"20%"}
                    height={20}
                    borderRadius={8}
                    style={{ marginBottom: "8px" }}
                  />
                  <Skeleton
                    width="60%"
                    height={20}
                    borderRadius={8}
                    style={{ marginBottom: "8px" }}
                  />
                </div >
              </div >
              <div className="category">
                <Skeleton
                  width={120}
                  height={20}
                  borderRadius={8}
                  style={{ marginBottom: "8px" }}
                />
              </div >
              <div className="validation_card">
                <div className="validation_grid">
                  <div>
                    <div>
                      <Skeleton
                        width={"64%"}
                        height={20}
                        borderRadius={8}
                        style={{ marginBottom: "8px" }}
                      />
                    </div>
                    <div>
                      <Skeleton
                        width={"100%"}
                        height={20}
                        borderRadius={8}
                        style={{ marginBottom: "8px" }}
                      />
                    </div>
                  </div >
                  <div>
                    <div>
                      <Skeleton
                        width={"64%"}
                        height={20}
                        borderRadius={8}
                        style={{ marginBottom: "8px" }}
                      />
                    </div>
                    <div>
                      <Skeleton
                        width={"100%"}
                        height={20}
                        borderRadius={8}
                        style={{ marginBottom: "8px" }}
                      />
                    </div >
                  </div >
                  <div>
                    <div>
                      <Skeleton
                        width={"64%"}
                        height={20}
                        borderRadius={8}
                        style={{ marginBottom: "8px" }}
                      />
                    </div>
                    <div>
                      <Skeleton
                        width={"100%"}
                        height={20}
                        borderRadius={8}
                        style={{ marginBottom: "8px" }}
                      />
                    </div >
                  </div >
                  <div>
                    <div>
                      <Skeleton
                        width={"64%"}
                        height={20}
                        borderRadius={8}
                        style={{ marginBottom: "8px" }}
                      />
                    </div>
                    <div>
                      <Skeleton
                        width={"100%"}
                        height={20}
                        borderRadius={8}
                        style={{ marginBottom: "8px" }}
                      />
                    </div >
                  </div >
                  <div>
                    <div>
                      <Skeleton
                        width={"64%"}
                        height={20}
                        borderRadius={8}
                        style={{ marginBottom: "8px" }}
                      />
                    </div>
                    <div>
                      <Skeleton
                        width={"100%"}
                        height={20}
                        borderRadius={8}
                        style={{ marginBottom: "8px" }}
                      />
                    </div >
                  </div >
                  {/* <div>
              <div>Methodology:</div>
              <div>CloseCarbon</div>
            </div> */}
                </ div>
 
                <div className="log">
                  <Skeleton
                    width={"20%"}
                    height={20}
                    borderRadius={8}
                    style={{ marginBottom: "8px" }}
                  />
                  <Skeleton
                    width="60%"
                    height={20}
                    borderRadius={8}
                    style={{ marginBottom: "8px" }}
                  />
                </div >
              </div >
            </>
          )}
        </div >
 
      </div >
    </div >
  );
};
 
export default Validation;
 
 
